// https://observablehq.com/@namitmohale/multi-line-chart@678
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Multi-Line Chart

Data: [Bureau of Labor Statistics](https://www.bls.gov/)`
)});
  main.variable(observer("chart")).define("chart", ["d3","width","height","titleText","margin","innerWidth","titleFontSize","xAxis","xAxisLabelSize","yAxis","yAxisLabelSize","data","dotSize","myColor","labelSize","highlightLineColor","line","hover"], function(d3,width,height,titleText,margin,innerWidth,titleFontSize,xAxis,xAxisLabelSize,yAxis,yAxisLabelSize,data,dotSize,myColor,labelSize,highlightLineColor,line,hover)
{
  const svg = d3.create("svg")
      .attr("viewBox", [0, 0, width, height])
      .style("overflow", "visible");
  
  // Title text
   svg.append('g').append('text')
     // .attr('class', 'title')
     .text(titleText)
     .attr('y', 10)
      .attr('x', margin.left + innerWidth/3)
     .attr('font-size', titleFontSize);
  
  
  svg.append("g")
      .call(xAxis)
      .attr('font-size', xAxisLabelSize);

  svg.append("g")
      .call(yAxis)
      .attr('font-size', yAxisLabelSize);
  
  
  const dots = svg.selectAll("mydots")
    .data(data.series)
    .enter()
    .append("circle")
    .attr("cx", 40 + innerWidth + margin.left)
    .attr("cy", function(d,i){ return 20 + i*25})
    .attr("r", dotSize)
    .style("fill", function(d){ return myColor(d.name)})
    
            
  const labels = svg.selectAll("mylabels")
    .data(data.series)
    .enter()
    .append("text")
    .attr("x", 60 + innerWidth + margin.left)
    .attr("y", function(d,i){ return 20 + i*25})
    .style("fill", function(d){ return myColor(d.name)})
    .text(function(d){ return d.name.length>20 ? d.name.charAt(0).toUpperCase() + d.name.slice(1,20) + '...' : d.name.charAt(0).toUpperCase() + d.name.slice(1)})
    .attr("text-anchor", "left")
    .style("alignment-baseline", "middle")
    .style("font-size", labelSize)


  const path = svg.append("g")
      .attr("fill", "none")
      .attr("stroke", highlightLineColor)
      .attr("stroke-width", 2.5)
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
    .selectAll("path")
    .data(data.series)
    .join("path")
      .style("mix-blend-mode", "multiply")
      .attr("d", d => line(d.values))
      .attr("stroke", (d,i) => myColor(d.name));
  
  svg.append('g').append('text')
     .attr('font-size', titleFontSize)
     .selectAll('text')
        .data(data)
        .join('text')
        .attr('y', 20)
        .attr('x', margin.left + innerWidth/3)
        .text(titleText)

  svg.call(hover, path, dots, labels);

  
  return svg.node();
}
);
  main.variable(observer("dataR")).define("dataR", function(){return(
{
  "y": "Num Polls",
  "series": [
    {
      "name": "Product Management",
      "values": [0,1,1,3,4,4,4,6,9,3,2,4,4,8]
    },
    {
      name: "Human Resources",
      values: [3,4,5,6,6,6,9,11,8,7,3,6,2,3]
    },
    {
      name: "Marketing",
      values: [0,0,0,0,2,2,1,3,3,2,2,5,5,1]
    },
    {
      name: "Data",
      values: [1,1,1,2,2,5,4,3,2,5,5,5,2,2]
    },
    {
      name: "Development",
      values: [0,1,3,5,3,2,1,0,2,3,8,5,3,6]
    }
  ],
  dates: ["2020-06-01","2020-06-08",
         "2020-06-15",
          "2020-06-22",
          "2020-06-29",
          "2020-07-06",
          "2020-07-13",
          "2020-07-20",
          "2020-07-27",
          "2020-08-03",
         "2020-08-10",
         "2020-08-17",
         "2020-08-24",
         "2020-08-31",]
}
)});
  main.variable(observer()).define(["dataR"], function(dataR){return(
dataR.dates
)});
  main.variable(observer()).define(["dataR","parseDate"], function(dataR,parseDate){return(
dataR.dates = (dataR.dates.map(q => {return parseDate(q)}))
)});
  main.variable(observer("data")).define("data", ["dataR"], function(dataR){return(
dataR
)});
  main.variable(observer("hover")).define("hover", ["dotSize","dotColor","toolTipTextSize","d3","x","y","data","formatDate","myColor"], function(dotSize,dotColor,toolTipTextSize,d3,x,y,data,formatDate,myColor){return(
function hover(svg, path, dots, labels) {
  
  if ("ontouchstart" in document) svg
      .style("-webkit-tap-highlight-color", "transparent")
      .on("touchmove", moved)
      .on("touchstart", entered)
      .on("touchend", left)
  else svg
      .on("mousemove", moved)
      .on("mouseenter", entered)
      .on("mouseleave", left);

  const dot = svg.append("g")
      .attr("display", "none");

  dot.append("circle")
      .attr("r", dotSize)
      .style("fill", dotColor);

  dot.append('g').append("text")
      .attr("font-family", "sans-serif")
      .attr("font-size", toolTipTextSize)
      .attr("text-anchor", "middle")
      .attr("y", -15);
  
  // dot.append('g')
  //    .attr('font-size', toolTipTextSize)
  //    .attr("text-anchor", "middle")
  //    .selectAll('text')
  //       .data(data)
  //       .join('text')
  //       .attr('y', -15).append("text")

  function moved(event) {
    event.preventDefault();
    const pointer = d3.pointer(event, this);
    const xm = x.invert(pointer[0]);
    const ym = y.invert(pointer[1]);
    const i = d3.bisectCenter(data.dates, xm);
    const s = d3.least(data.series, d => Math.abs(d.values[i] - ym));
    path.attr("stroke", d => d === s ? null : "#ddd").filter(d => d === s).raise();
    dot.attr("transform", `translate(${x(data.dates[i])},${y(s.values[i])})`);
    dot.select("text").text(s.name+" Polls (" + formatDate(data.dates[i]) + "): " +s.values[i])
  }

  function entered() {
    path.style("mix-blend-mode", null).attr("stroke", "#ddd");
    dot.attr("display", null);
    // dots.style("fill", "#ddd");
  }

  function left() {
    path.style("mix-blend-mode", "multiply").data(data.series).attr("stroke", (d,i) => myColor(d.name));
    dot.attr("display", "none");
  }
}
)});
  main.variable(observer("myColor")).define("myColor", ["d3","data"], function(d3,data){return(
d3.scaleOrdinal()
            .domain(data.series.map(val => {return val.name}))
            .range(d3.schemeSet2)
)});
  main.variable(observer("yLabelTextSize")).define("yLabelTextSize", function(){return(
12
)});
  main.variable(observer("xAxisLabelSize")).define("xAxisLabelSize", function(){return(
10
)});
  main.variable(observer("yAxisLabelSize")).define("yAxisLabelSize", function(){return(
10
)});
  main.variable(observer("labelSize")).define("labelSize", function(){return(
15
)});
  main.variable(observer("formatDate")).define("formatDate", ["d3"], function(d3){return(
d3.timeFormat("%B %d")
)});
  main.variable(observer("titleFontSize")).define("titleFontSize", function(){return(
10
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
"Number of Polls for Teams"
)});
  main.variable(observer("highlightLineColor")).define("highlightLineColor", function(){return(
"steelblue"
)});
  main.variable(observer("parseDate")).define("parseDate", ["d3"], function(d3){return(
d3.utcParse("%Y-%m-%d")
)});
  main.variable(observer("dotSize")).define("dotSize", function(){return(
10
)});
  main.variable(observer("dotColor")).define("dotColor", function(){return(
"steelblue"
)});
  main.variable(observer("toolTipTextSize")).define("toolTipTextSize", function(){return(
12
)});
  main.variable(observer("height")).define("height", ["width"], function(width){return(
width / 2
)});
  main.variable(observer("width")).define("width", function(){return(
900
)});
  main.variable(observer("innerWidth")).define("innerWidth", ["width","margin"], function(width,margin){return(
width - margin.left - margin.right
)});
  main.variable(observer("innerHeight")).define("innerHeight", ["height","margin"], function(height,margin){return(
height - margin.top - margin.bottom
)});
  main.variable(observer("margin")).define("margin", function(){return(
{top: 50, right: 200, bottom: 30, left: 30}
)});
  main.variable(observer("x")).define("x", ["d3","data","margin","innerWidth"], function(d3,data,margin,innerWidth){return(
d3.scaleUtc()
    .domain(d3.extent(data.dates))
    .range([margin.left, innerWidth+ margin.left])
)});
  main.variable(observer("y")).define("y", ["d3","data","height","margin"], function(d3,data,height,margin){return(
d3.scaleLinear()
    .domain([0, d3.max(data.series, d => d3.max(d.values))]).nice()
    .range([height - margin.bottom, margin.top])
)});
  main.variable(observer("xAxis")).define("xAxis", ["height","margin","d3","x","width"], function(height,margin,d3,x,width){return(
g => g
    .attr("transform", `translate(0,${height - margin.bottom})`)
    .call(d3.axisBottom(x).ticks(width / 80).tickSizeOuter(0))
)});
  main.variable(observer("yAxis")).define("yAxis", ["margin","d3","y","yLabelTextSize","data"], function(margin,d3,y,yLabelTextSize,data){return(
g => g
    .attr("transform", `translate(${margin.left},0)`)
    .call(d3.axisLeft(y))
    .call(g => g.select(".domain").remove())
    .call(g => g.select(".tick:last-of-type text").clone()
        .attr("x", -20)
        .attr("y", -20)
        .attr("text-anchor", "start")
        .attr("font-weight", "bold")
          .attr("font-size", yLabelTextSize)
        .text(data.y))
)});
  main.variable(observer("line")).define("line", ["d3","x","data","y"], function(d3,x,data,y){return(
d3.line()
    .defined(d => !isNaN(d))
    .x((d, i) => x(data.dates[i]))
    .y(d => y(d))
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@^6.1")
)});
  return main;
}
